import { UseFormReturn } from "react-hook-form";
import FormSection from "../form-fields/FormSection";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { VisaPathway } from "../VisaPathwaySelection";

interface RecognitionProps {
  form: UseFormReturn<any>;
  visaPathway: VisaPathway;
}

const Recognition = ({ form }: RecognitionProps) => {
  return (
    <FormSection
      title="Prizes, Awards & Recognitions"
      description="Tell us about any recognition you've received for your work."
    >
      <div className="space-y-8">
        <FormField
          control={form.control}
          name="recognition.excellenceAwards"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Have you received any prizes or awards of excellence in the last 5 years? *</FormLabel>
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className="flex flex-col space-y-2"
                >
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="none" />
                    </FormControl>
                    <FormLabel className="font-normal">None</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="one" />
                    </FormControl>
                    <FormLabel className="font-normal">One</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="two_or_more" />
                    </FormControl>
                    <FormLabel className="font-normal">Two or more</FormLabel>
                  </FormItem>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="recognition.awardRecognition"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Is the prize(s) and/or award(s) recognized nationally or internationally? *</FormLabel>
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className="flex flex-col space-y-2"
                >
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="national" />
                    </FormControl>
                    <FormLabel className="font-normal">Nationally</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="international" />
                    </FormControl>
                    <FormLabel className="font-normal">Internationally</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="both" />
                    </FormControl>
                    <FormLabel className="font-normal">Both</FormLabel>
                  </FormItem>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </FormSection>
  );
};

export default Recognition;